import React from 'react';
import { motion } from 'framer-motion';
import { FiAward, FiExternalLink } from 'react-icons/fi';

const Certificates = ({ certificates }) => {
  return (
    <section className="section-padding bg-[#F5F2E8] dark:bg-gray-900">
      <div className="container-max">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Certificates & Achievements
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {certificates.map((cert, index) => (
            // Use an anchor tag <a> to make the card a link
            <a
              key={index}
              href={cert.link || '#'} // Use the new 'link' property
              target="_blank"
              rel="noopener noreferrer"
            >
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
                whileHover={{ y: -3 }}
                className="card group h-full" // Added h-full for consistent height
              >
                <div className="relative overflow-hidden rounded-lg mb-4 h-56 bg-white dark:bg-gray-800">
                  <img
                    src={process.env.PUBLIC_URL + cert.image}
                    alt={cert.name}
                    className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-[1.02]"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <FiExternalLink className="text-white text-3xl" />
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <FiAward className="text-blue-600 text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                        {cert.name}
                      </h3>
                      <p className="text-blue-600 dark:text-blue-400 font-medium">
                        {cert.issuer}
                      </p>
                      <p className="text-sm text-gray-500 dark:text-gray-400">
                        {cert.date}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certificates;